@for (element of dashboardElements; track element.id) {
	@if (element.type == dashboardType.Information) {
		<panel>
			@if (element.configuration?.header) {
				<h1>{{ element.configuration?.header }}</h1>
			}
			<section scrollable>
				<div class="text-block" [formattedContent]="element.configuration?.content" [isHtmlContent]="true"></div>
			</section>
		</panel>
	}
	@else if (element.type == dashboardType.Absence) {
		<absence />
	}
}
